import React from 'react'
import V2Layout from '../../components/V2Layout'
import './ProductsPage.css'

/**
 * Shared shell for all product pages.
 * Uses the site-wide V2Layout (unified navbar) + product category tabs below.
 */
const ProductLayout = ({ children }) => {
    return (
        <V2Layout pageClass="pfc-products-page">
            <div className="pfc-products-shell" style={{ minHeight: 0 }}>
                {children}
            </div>
        </V2Layout>
    )
}

export default ProductLayout
